import React from "react";
import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateSixPDFSectionWithSubsections as TemplateSixPDFSection } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeEducation } from "lib/redux/types";
import { Black_Han_Sans } from "next/font/google";

export const Education = ({
  heading,
  educations,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  educations: ResumeEducation[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      {educations.map(
        (
          { school, degree, startDate, endDate, gpa, descriptions = [] },
          idx
        ) => {
          // Hide school name if it is the same as the previous school
          const hideSchoolName =
            idx > 0 && school === educations[idx - 1].school;

          return (
            <View 
              key={idx} 
              style={{ marginTop: spacing[2] }}
              wrap={false} // Prevent individual education items from splitting across pages
            >
              {!hideSchoolName && (
                <View style={styles.flexRowBetween}>
                  <ResumePDFText bold={true} style={{ marginBottom: spacing[1] }}>
                    {school}
                  </ResumePDFText>
                  <ResumePDFText>
                    {startDate && endDate
                      ? `${startDate} - ${endDate}`
                      : startDate || endDate}
                  </ResumePDFText>
                </View>
              )}
              <View style={styles.flexCol}>
                <ResumePDFText>
                  {gpa ? `${degree} - ${gpa}` : degree}
                </ResumePDFText>
              </View>
              <View
                style={{
                  ...styles.flexCol,
                  marginTop: spacing[1],
                  marginBottom: spacing[2],
                  width: "65%",
                }}
              >
                <ResumePDFDescription 
                  items={descriptions} 
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableHighlight}
                  section="education"
                  itemIndex={idx}
                />
              </View>
            </View>
          );
        }
      )}
    </TemplateSixPDFSection>
  );
};
